/**
 * Choose the portfolio equity to attribute a day's realized P/L against.
 * Prefer the latest snapshot strictly before midnight (prior-day close) so
 * the percent reflects "how much did trades move the account from where it
 * started." Fall back to the first snapshot of the day if no prior data
 * exists (e.g. snapshot recording started today). `points` must be sorted
 * by `t` ascending — which is how /api/portfolio/snapshots returns them.
 */
export function pickStartOfDayEquity(
  points: { t: number; v: number }[],
  dayStartMs: number,
): number | undefined {
  let prevClose: number | undefined
  for (const p of points) {
    if (p.t < dayStartMs) {
      prevClose = p.v
      continue
    }
    return prevClose ?? p.v
  }
  return prevClose
}
